import lottie from "lottie-web";

function triggerLottie(element: Element) {
  const lottieFile = element.getAttribute("data-lottie");
  if (lottieFile) {
    lottie.loadAnimation({
      container: element,
      renderer: "svg",
      loop: true,
      path: lottieFile,
    });
  }
}

document.addEventListener("aos:in", ({ detail }) => {
  if (
    detail.classList.contains("lottie-web") &&
    detail.classList.contains("aos-animate")
  ) {
    triggerLottie(detail);
  }
});
window.addEventListener("load", () => {
  // AOS disabled on mobile. Trigger animation anyways.
  if (window.innerWidth < 1024) {
    document.querySelectorAll(".lottie-web").forEach((element) => {
      triggerLottie(element);
    });
  }
});
